import { render } from "./refereeDetails.vue?vue&type=template&id=3221417c&ts=true"
import script from "./refereeDetails.vue?vue&type=script&lang=ts"
export * from "./refereeDetails.vue?vue&type=script&lang=ts"

import "./refereeDetails.vue?vue&type=style&index=0&id=3221417c&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__